import { Injectable } from '@angular/core';

declare let slab_AB: any;
declare let pg_paypal_AB: any;
declare let story_image_AB: any;
declare let ty_sip_amt_AB: any;
declare let story_ABC: any;
declare let story_ABC_mweb: any;
declare let thank_you_AB: any;
declare let story_title_ABC: any;

@Injectable({
  providedIn: 'root'
})
export class ABService {

  constructor() { }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
  }

  pg_paypal_AB() {
    const sessionData = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('pg_paypal_AB') : undefined;
    if (sessionData) {
      return sessionData;
    }
    if (typeof pg_paypal_AB !== 'undefined') {
      sessionStorage.setItem('pg_paypal_AB', pg_paypal_AB);
      return pg_paypal_AB;
    }
  }

  story_image_AB() {
    if (typeof story_image_AB !== 'undefined') {
      return story_image_AB;
    }
  }

  ty_sip_amt_AB() {
    if (typeof ty_sip_amt_AB !== 'undefined') {
      return ty_sip_amt_AB;
    }
  }

  story_ABC() {
    if (typeof story_ABC !== 'undefined') {
      return story_ABC;
    }
  }

  story_ABC_mweb() {
    if (typeof story_ABC_mweb !== 'undefined') {
      return story_ABC_mweb;
    }
  }

  story_title_ABC() {
    if (typeof story_title_ABC !== 'undefined') {
      return story_title_ABC;
    }else{
      return '';
    }
  }

  thank_you_AB() {
    if (typeof thank_you_AB !== 'undefined') {
      return thank_you_AB;
    }
  }

}
